import { getRanking as getRankingFromAPI } from '@/api/newPlatform/ranking.api'

export const getRanking = async (userId: string, courseId: string) => {
  const response = await getRankingFromAPI(userId, courseId)

  return response
}
